import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Copyright from "../../internals/components/Copyright";
import MainWithdrawals from "./MainWithdrawals";

const MainWithdrawal = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	return (
		<Box sx={{ width: "100%", minWidth: 380, maxWidth: 500 }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Withdrawal
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<MainWithdrawals token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default MainWithdrawal;
